import clsx from "clsx";
import { PrismicLink } from "@prismicio/react";
import prismic from "@prismicio/client";
import clsxT from "clsx";

const baseStyles = {
  solid:
    "group inline-flex items-center justify-center rounded-sm py-2 px-4 text-sm font-normal focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2",
  outline:
    "group inline-flex ring-1 items-center justify-center rounded-sm py-2 px-4 text-sm focus:outline-none",
};

const variantStyles = {
  solid: {
    slate:
      "bg-slate-900 text-white hover:bg-slate-700 hover:text-slate-100 active:bg-slate-800 active:text-slate-300 focus-visible:outline-slate-900",
    blue: "bg-blue-600 text-white hover:text-slate-100 hover:bg-blue-500 active:bg-blue-800 active:text-blue-100 focus-visible:outline-blue-600",
    white:
      "bg-white text-slate-900 hover:text-white hover:bg-primary active:bg-primary active:text-slate-600 drop-shadow-md",
    primary:
      "bg-black text-white hover:bg-primary active:bg-green-800 active:text-green-100 focus-visible:outline-green-600 transition duration-300 ease-in-out",
    secondary:
      "bg-slate-900 text-white hover:bg-primary active:bg-green-800 active:text-green-100 focus-visible:outline-green-600 transition duration-300 ease-in-out",
    black:
      "bg-black text-white hover:bg-primary transition duration-300 ease-in-out",
  },
  outline: {
    slate:
      "ring-slate-200 text-slate-700 hover:text-slate-900 hover:ring-slate-300 active:bg-slate-100 active:text-slate-600 focus-visible:outline-blue-600 focus-visible:ring-slate-300",
    white:
      "ring-slate-700 text-white hover:ring-slate-500 active:ring-slate-700 active:text-slate-400 focus-visible:outline-white",
    primary:
      "ring-primary text-slate-900 hover:ring-primary-500 active:ring-primary-700 active:text-primary-400 focus-visible:outline-primary",
  },
};

export function Button({
  variant = "solid",
  color = "slate",
  className,
  href = "#",
  field,
  submit,
  ...props
}) {
  className = clsx(
    baseStyles[variant],
    variantStyles[variant][color],
    className
  );

  if (submit) {
    return <button type="submit" className={className} {...props} />;
  }

  return field ? (
    // <Link href={href} className={className} {...props} />
    <PrismicLink className={className} {...props} field={field} />
  ) : (
    // <button className={className} {...props} />
    <PrismicLink className={className} {...props} href={href} />
  );
}
